module.exports = __webpack_public_path__ + "pin_green.9bb69a.png";